// src/components/SubmitButton.jsx
import React from 'react';
import { Spinner } from 'flowbite-react'; // Still need Spinner for loading state


const SubmitButton = ({
    isLoading,
    children,
    loadingText = 'Loading...',
    // Default primary styling. We will explicitly add padding, font size, etc.
   className = '', // Start with an empty string, we'll build the default styles below
    ...rest // Capture any other props (e.g., onClick, form attributes)
}) => {
    // Define the base Tailwind classes for a standard button
    // These are crucial for consistent sizing and styling without Flowbite's defaults
    const baseButtonClasses = `
        w-full
        flex items-center justify-center 
        px-4 py-2.5 // Explicit padding to control height and width. Adjust py- and px- as needed!
        text-base font-medium text-white
        rounded-lg 
        shadow-sm 
        bg-primary-brand
        hover:bg-primary-brand-darker 
        transition ease-in-out duration-150
        ${isLoading ? 'opacity-75 cursor-not-allowed' : ''} 
    `;

    return (
        <button
            type="submit" // Ensure it's always a submit button
            className={`${baseButtonClasses} ${className}`} // Combine base classes with any passed in className
            disabled={isLoading} // Disable when loading
            {...rest} // Pass any additional props
        >
            {isLoading ? (
                <>
                    <Spinner size="sm" className="mr-3" />
                    {loadingText}
                </>
            ) : (
                children
            )}
        </button>
    );
};

export default SubmitButton;